module.exports = __webpack_public_path__ + "static/media/icra25vovapresentation.91ffe22f.jpeg";